import React from 'react';
import { AnimatedBottomBannerView } from './view';
import { styles } from './styles';

export class AnimatedBottomBanner extends React.Component {
  render() {
    return <AnimatedBottomBannerView {...this.props} styles={styles} />;
  }
}
